module.exports = __webpack_public_path__ + "img/6.f0e629d4.jpg";